// src/services/api.service.js
import { API_PREFIX } from '../config/appConfig';

// Servizio base per le chiamate API
const ApiService = {
  fetch: async (endpoint, options = {}) => {
      const defaultHeaders = {
          'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
      };

      // Se non è un FormData, aggiungi gli headers per JSON
      if (!(options.body instanceof FormData)) {
          defaultHeaders['Content-Type'] = 'application/json';
          defaultHeaders['Accept'] = 'application/json';
      }

      console.log('[DEBUG] API Call:', {
          url: `${API_PREFIX}/${endpoint}`,
          method: options.method,
          isFormData: options.body instanceof FormData,
          headers: {
              ...defaultHeaders,
              ...options.headers
          }
      });

      try {
          const response = await fetch(`${API_PREFIX}/${endpoint}`, {
              ...options,
              headers: {
                  ...defaultHeaders,
                  ...options.headers
              }
          });

          if (!response.ok) {
              const error = await response.json();
              throw new Error(error.message || 'API Error');
          }

          return response.json();
      } catch (error) {
          console.error('[DEBUG] API Error:', error);
          throw error;
      }
  }
};

export default ApiService;